import { useDimensions } from 'react-native-web-hooks';

const useFontSize = (number: number) => {
    const { height, width, scale, fontScale } = useDimensions().window;

    return (Math.min(height, width) * (number)) / 100 + 4.5;


};

export default useFontSize;